import { useFlags } from 'launchdarkly-react-client-sdk';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import type { Dispensaries } from 'src/gql/graphql';

function getCategoryMenuOrder(dispensary: Dispensaries, category: string, isV2Enabled: boolean): string | undefined {
  const { menuSortSettings, menuOrderSettings } = dispensary;

  if (isV2Enabled) {
    return menuOrderSettings.find((setting) => setting.category === category)?.menuOrder;
  }

  return menuSortSettings?.find((setting) => setting.category === category)?.menuOrder;
}

/**
 * Gets the menu order for a specific category
 * Falls back to default menu order if no category-specific setting exists
 * @param {string} [category] - Optional category to get menu order for
 * @returns {string|undefined} The menu order for the category
 */
export function useDispensaryMenuOrder(category?: string): string | undefined {
  const { dispensary } = useDispensary();
  const flags = useFlags();
  const isV2Enabled = flags['ecomm.admin.menu-v2.rollout'] ?? false;

  // Early return if dispensary is not available
  if (!dispensary) {
    return undefined;
  }

  if (!category) {
    return dispensary.menuOrder ?? undefined;
  }

  return getCategoryMenuOrder(dispensary, category, isV2Enabled) ?? dispensary.menuOrder;
}
